import moment from 'moment';
import { FinanceFilters, FinanceFilterType } from './types';

export const initialFinanceFiltersValue: FinanceFilters = {
  [FinanceFilterType.DEAL_DATE]: {
    to: moment().endOf('month'),
    from: moment().startOf('month'),
  },
  [FinanceFilterType.SALES_REP]: [],
  [FinanceFilterType.LOCATION]: [],
};
